import script from "./PatientRegisterIPDList.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientRegisterIPDList.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__